import { auth } from '../../../config/firebaseConfig';

// Dilekçe türleri: `label` kayda ve DOCX'e Türkçe yazılır; ekranda `value` ile çevrilir
export const COMPLAINT_TYPES = [
  { value: 'sikayet', label: 'Şikayet Dilekçesi' },
  { value: 'talep', label: 'Talep Dilekçesi' },
  { value: 'itiraz', label: 'İtiraz Dilekçesi' },
  { value: 'mobbing', label: 'Mobbing Bildirimi' },
  { value: 'cinsel_taciz', label: 'Cinsel Taciz Bildirimi' },
  { value: 'sozlu_taciz', label: 'Sözlü Taciz Bildirimi' },
  { value: 'fiziksel_taciz', label: 'Fiziksel Taciz Bildirimi' },
  { value: 'psikolojik_siddet', label: 'Psikolojik Şiddet Bildirimi' },
  { value: 'ayrimcilik', label: 'Ayrımcılık Bildirimi' },
  { value: 'is_guvenligi', label: 'İş Güvenliği İhlali Bildirimi' },
  { value: 'etik_ihlali', label: 'Etik İhlal Bildirimi' },
  { value: 'oneri', label: 'Öneri Dilekçesi' },
  { value: 'diger', label: 'Diğer' },
];

// Durumlar (kayıttaki değerler)
export const COMPLAINT_STATUSES = ['PENDING', 'INCELENIYOR', 'RESOLVED', 'CLOSED'];

export const COMPLAINT_STATUS_TONES = {
  PENDING: 'warning',
  INCELENIYOR: 'info',
  RESOLVED: 'success',
  CLOSED: 'neutral',
};

/** Bilinmeyen durum eskisi gibi "Kapatıldı" sayılır. */
export const complaintStatusKey = (status) => (COMPLAINT_STATUSES.includes(status) ? status : 'CLOSED');

/** Dilekçe türünün ekrandaki adı; listede olmayan tür kayıttaki etiketiyle. */
export const complaintTypeLabel = (t, complaint) => {
  const known = COMPLAINT_TYPES.some((type) => type.value === complaint.type);
  return known ? t(`profilePage.complaints.types.${complaint.type}`) : (complaint.typeLabel || complaint.type || '');
};

/**
 * Dilekçenin gönderilebileceği yetkililer. Ana admin test için kendine de
 * gönderebilir.
 */
export const getComplaintTargets = () => {
  const baseTargets = [
    { email: 'hatice.alev@habcare.com.tr', name: 'Hatice Alev' },
    { email: 'arife.sahin@habcare.com.tr', name: 'Arife Şahin' },
  ];

  const currentUserEmail = auth.currentUser?.email?.toLowerCase();
  if (currentUserEmail === 'turanemre1999@gmail.com') {
    return [
      { email: 'turanemre1999@gmail.com', name: 'Kendime Gönder (Test)', isTest: true },
      ...baseTargets,
    ];
  }

  return baseTargets;
};

/** Firestore Timestamp, Date ya da metin → Date. */
export const toDate = (value) => (value?.toDate ? value.toDate() : new Date(value));

/** Dilekçe ve yanıt tarihleri: "9 Ekim 2026". */
export const formatLongDate = (value, locale) => {
  const date = toDate(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString(locale, { day: 'numeric', month: 'long', year: 'numeric' });
};
